import React from 'react'
import {List, RowComponentProps, useListRef, useDynamicRowHeight} from 'react-window'

import RouteListItem from './RouteListItem.js'
import {User} from '../../../server/functions/users/users.types.js'
import {FrontEndRoute} from '../../../server/functions/route/route.types.js'
import {Reseller} from '../../../server/functions/resellers/resellers.types.js'
import {RouteBulkAction} from '../../utils/routeBulkActions.js'

type RouteOverlapData = {
    overlappingVehicleIds: Record<string, boolean>
    overlappingMessengerIds: Record<string, boolean>
    routeOverlaps: boolean
    messengerOverlaps: boolean
}

type RouteListProps = {
    routes: FrontEndRoute[]
    users: User[]
    focusedRouteId: string
    selectedRouteId: string
    reseller: Reseller
    routeOverlapDataById: Record<string, RouteOverlapData>
    view: 'expanded' | 'collapsed'
    onEditRoute: (route: FrontEndRoute) => void
    bulkAction: RouteBulkAction | ''
    bulkSelectedIds: Record<string, boolean>
    bulkRunning: boolean
    onToggleBulkSelect: (routeId: string, event?: {shiftKey?: boolean}) => void
}

type RouteRowProps = {
    routes: FrontEndRoute[]
    users: User[]
    focusedRouteId: string
    selectedRouteId: string
    reseller: Reseller
    routeOverlapDataById: Record<string, RouteOverlapData>
    view: 'expanded' | 'collapsed'
    onEditRoute: (route: FrontEndRoute) => void
    bulkAction: RouteBulkAction | ''
    bulkSelectedIds: Record<string, boolean>
    bulkRunning: boolean
    onToggleBulkSelect: (routeId: string, event?: {shiftKey?: boolean}) => void
}

const RouteRow = ({index, style, routes, users, focusedRouteId, selectedRouteId, reseller, routeOverlapDataById, view, onEditRoute, bulkAction, bulkSelectedIds, bulkRunning, onToggleBulkSelect}: RowComponentProps<RouteRowProps>) => {
    const route = routes[index]

    return (
        <div
            style={{
                ...style,
                paddingBottom: 6,
                boxSizing: 'border-box',
                zIndex: routes.length - index,
                overflow: 'visible'
            }}
        >
            <RouteListItem
                users={users}
                route={route}
                onEditRoute={onEditRoute}
                focusedRouteId={focusedRouteId}
                selectedRouteId={selectedRouteId}
                reseller={reseller}
                routeOverlapData={routeOverlapDataById[route._id]}
                view={view}
                bulkAction={bulkAction}
                bulkSelected={!!bulkSelectedIds[route._id]}
                bulkRunning={bulkRunning}
                onToggleBulkSelect={onToggleBulkSelect}
            />
        </div>
    )
}

export default function RouteList({routes, users, focusedRouteId, selectedRouteId, reseller, routeOverlapDataById, view, onEditRoute, bulkAction, bulkSelectedIds, bulkRunning, onToggleBulkSelect}: RouteListProps) {
    const listRef = useListRef(null)

    const rowHeight = useDynamicRowHeight({
        defaultRowHeight: view === 'expanded' ? 255 : 86
    })

    return (
        <div style={{flex: 1, width: '100%', overflowY: 'auto', padding: 6}}>
            <List
                style={{zIndex: 1}}
                rowComponent={RouteRow}
                rowCount={routes.length}
                rowHeight={rowHeight}
                rowProps={{routes, users, focusedRouteId, selectedRouteId, reseller, routeOverlapDataById, view, onEditRoute, bulkAction, bulkSelectedIds, bulkRunning, onToggleBulkSelect}}
                listRef={listRef}
                overscanCount={6}
            />
        </div>
    )
}
